exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__CropWaterPanel__panel__p9UPd {\n  background: white;\n  height: auto;\n  position: static;\n}\n\n.dmb-web__CropWaterPanel__events__jm-y1 {\n  background: white;\n  height: auto;\n  padding-top: 48px;\n}\n", ""]);

// exports
exports.locals = {
	"panel": "dmb-web__CropWaterPanel__panel__p9UPd",
	"events": "dmb-web__CropWaterPanel__events__jm-y1"
};